const columnWidths = {
  index: 7,
  fullname: 17,
  fulldate: 7,
  origin: 27,
  destination: 27,
  toll: 6,
  price: 9,
};

export const restrictedTableColumns = [
  { key: "index", field: "order_number", label: "No", width: 7 },
  { key: "fulldate", field: "date", label: "FECHA", width: 14 },
  { key: "time", field: "time", label: "HORA", width: 9 },
  { key: "origin", field: "origin_name", label: "ORIGEN", width: 24 },
  { key: "destination", field: "destination_name", label: "DESTINO", width: 24 },
  { key: "notes", field: "notes", label: "NOTA", width: 22 },
];

export const getTableColumnStyles = (canViewTotal) => {
  const visibleColumns = canViewTotal
    ? columnWidths
    : Object.fromEntries(restrictedTableColumns.map(({ key, width }) => [key, width]));
  const visibleWidth = Object.values(visibleColumns).reduce(
    (total, width) => total + width,
    0
  );
  const widths = canViewTotal
    ? {
        ...visibleColumns,
        fullHour: columnWidths.fulldate + 8,
        originHour: columnWidths.origin + columnWidths.destination - 8,
      }
    : visibleColumns;

  return Object.fromEntries(
    Object.entries(widths).map(([column, width]) => [
      column,
      {
        width: `${(width / visibleWidth) * 100}%`,
        flexShrink: 0,
      },
    ])
  );
};
